"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var tfs_icon_1 = __importDefault(require("tfs.icon"));
exports.default = (function (_a) {
    var _b, _c;
    var classes = _a.classes, className = _a.className, isDisabled = _a.isDisabled, children = _a.children, icon = _a.icon, onClick = _a.onClick, name = _a.name, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'left' : _d, _e = _a.color, color = _e === void 0 ? 'ruby' : _e, _f = _a.type, type = _f === void 0 ? 'button' : _f, rest = __rest(_a, ["classes", "className", "isDisabled", "children", "icon", "onClick", "name", "iconPosition", "color", "type"]);
    return (react_1.default.createElement("button", __assign({}, rest, { type: type, name: name, className: classnames_1.default(classes.button, (_b = {},
            _b["" + className] = className,
            _b[classes.colorGreen] = color === 'green',
            _b[classes.colorBlue] = color === 'blue',
            _b[classes.colorWhite] = color === 'white',
            _b[classes.colorTransparent] = color === 'transparent',
            _b[classes.disabled] = isDisabled,
            _b)), disabled: isDisabled, onClick: function (e) {
            return !isDisabled && onClick ? onClick(e) : false;
        } }),
        icon && (react_1.default.createElement(tfs_icon_1.default, { name: icon, className: classnames_1.default(classes.icon, (_c = {},
                _c[classes.iconRight] = iconPosition === 'right',
                _c)) })),
        react_1.default.createElement("span", { className: classes.children }, children)));
});
//# sourceMappingURL=Button.js.map